import { render, staticRenderFns } from "./DeviceSetup.vue?vue&type=template&id=8474dc88&scoped=true"
import script from "./DeviceSetup.vue?vue&type=script&lang=ts"
export * from "./DeviceSetup.vue?vue&type=script&lang=ts"
import style0 from "./DeviceSetup.vue?vue&type=style&index=0&id=8474dc88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8474dc88",
  null
  
)

export default component.exports